import { useForm } from "react-hook-form";
import Box from "../../../shared/box/Box";
import Select from "../../../shared/select";
import Button from "../../../shared/button";
import { useCustomerCallTopUpsMutation } from "../../../store/payments/paymentsApi";
import { useStripe } from "@stripe/react-stripe-js";

interface IPayProps {
  amount: number;
  paymentMethodId: string;
}

const ChoosePayment = ({
  list,
  customerId,
}: {
  list: {
    label: string;
    value: string;
  }[];
  customerId: string;
}) => {
  const stripe = useStripe();
  const [callTopUps, { isLoading: isTopUpLoading }] =
    useCustomerCallTopUpsMutation();
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<IPayProps>({
    defaultValues: {
      amount: 20,
    },
  });

  const onSubmit = async ({ amount, paymentMethodId }: IPayProps) => {
    console.log({ paymentMethodId, amount: +amount, customerId });
    try {
      const res = await callTopUps({
        amount,
        currency: "USD",
        customerId,
        paymentMethodId,
      }).unwrap();

      console.log({ res });

      if (!stripe) return;
      const { error } = await stripe.confirmCardPayment(res.data.clientSecret);
      if (error) {
        //   setPaymentError(`Payment failed: ${error.message}`);
      } else {
        //   setPaymentSuccess(true);
      }
    } catch (e) {
      console.error({ e });
    }
  };

  return (
    <div className="w-full md:w-6/12 mx-auto sszzz">
      <Box title="Credit or debit card">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-row items-center"
        >
          <div className="flex flex-row items-center">
            <div className="m-3 font-semibold text-center w-24">
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(watch("amount"))}
            </div>
            <input
              type="range"
              id="range"
              min={5}
              step={5}
              max={10000}
              {...register("amount")}
              className={"border border-borderColor rounded w-full px-3 py-2"}
            />
          </div>
          <div className="w-52 mx-7">
            <label
              htmlFor=""
              className="text-primary-light font-normal text-base"
            >
              Payment Method
            </label>
            <Select
              register={register("paymentMethodId", {
                required: "Payment method is required",
              })}
              error={errors.paymentMethodId?.message}
              placeholder="Choose a payment"
              options={list}
            />
          </div>
          <Button label="Pay" type="submit" loading={isTopUpLoading} />
        </form>
      </Box>
    </div>
  );
};

export default ChoosePayment;
